// extracted by mini-css-extract-plugin
export default {"loading":"_2C4QbwNqE6Jw4wz7v6CMAI"};